// extracted by mini-css-extract-plugin
export default {"root":"widget_root__3UrEM","container":"widget_container__GSyOA","loader":"widget_loader__km9vX"};